import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { CommonApiData } from "../../EnvConfig/env_config";
import { NotificationSound } from "../CommonComponents/CommonNotification";
import { FindTranslatedKey } from "../CommonComponents/CustomHooks";
import { BulkClearData, DownloadFileAtURL, ERRORDATALIST, HandleBulkInsertData, readFile2 } from "../CommonComponents/ExportData";
import { ImportButton } from "../CommonComponents/InputBox";
const ImportPacketBooking = ({ menuText }) => {
    const [ImportData, setImportData] = useState({ sheet1: [], sheet2: [], sheet3: [] });

    const [Status, setStatus] = useState([]);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const PageType = searchParams.get('PageType');
    const [Name, setName] = useState('');
    const dispatch = useDispatch();
    const ErrorData = async () => {
        await ERRORDATALIST(Status, 'PacketBooking_Error')
    };
    const validateHeaders = (sheet1, sheet2, sheet3) => {
        debugger;
        const requiredHeaders1 = ["AwbNo", "Pieces", "Totalvalue", "Currency", "ActualWeight", "WeightUnit", "PerKGRate", "PacketType", "PaymentType", "CODAmount"];
        const requiredHeaders2 = ["AwbNo", "Length", "Breadth", "Height"];
        const requiredHeaders3 = ["AwbNo", "Description", "HsNo", "UniqueQuantity", "UnitValue", "Units"];
        if (!sheet1.length) {
            /*|| !sheet2.length || !sheet3.length*/
            return false;
        }
        const dataHeaders1 = Object.keys(sheet1[0]);
        const dataHeaders2 = Object.keys(sheet2?.[0] ?? {});
        const dataHeaders3 = Object.keys(sheet3?.[0] ?? {});
        const sheet1Valid = requiredHeaders1.every(header => dataHeaders1.includes(header));
        const sheet2Valid =!sheet2?.length || requiredHeaders2.every(header => dataHeaders2.includes(header));
        const sheet3Valid =!sheet3?.length ||requiredHeaders3.every(header => dataHeaders3.includes(header));
        return sheet1Valid && sheet2Valid && sheet3Valid;
    };

    const BulkSubmit = async (e) => {
        try {
            const data = await readFile2(e);
            console.log('Data from readFile:', data);
            setImportData({ sheet1: data.sheet1, sheet2: data.sheet2, sheet3: data.sheet3 });
            setName(data.FileName);
        } catch (error) {
            console.error('Error in BulkSubmit:', error);
            await NotificationSound('ERROR', 'Error processing file. Please try again.');
        }
    };

    const handleBulk = async () => {
        const Data2 = {
            Type: PageType,
            "Token": CommonApiData().Token,
            "LoginUserCode": CommonApiData().LoginUserCode,
            "LoginBCode": CommonApiData().loginBCode,
            "Source": 'Web',
            "User": CommonApiData().UserName,
            "awbNo": '',
        };
        const divisor = 5000; // Divisor value as mentioned
        const calculateVolWeight = (length, width, height) => {
            if (!length || !width || !height) return '';
            return ((length * width * height) / divisor).toFixed(3);
        };
        if ((ImportData && ImportData.sheet1.length !== 0)) {
            /*&& (ImportData && ImportData.sheet2.length !== 0) && (ImportData && ImportData.sheet3.length !== 0)*/

            if (validateHeaders(ImportData.sheet1, ImportData.sheet2, ImportData.sheet3)) {
                const groupedData = groupDataByProductCode(ImportData.sheet1, ImportData.sheet2, ImportData.sheet3);
                ImportData.sheet2.forEach(item => {
                    const volWeight = calculateVolWeight(Number(item.Length), Number(item.Breadth), Number(item.Height));
                    item.volWeight = volWeight;

                });
                const Data = await HandleBulkInsertData('/api/Operation/UpdateWeightDetailPacketBooking', groupedData, Data2, () => { setName('') });
                if (Data.status === 'EXPIRED') {
                    await NotificationSound(Data.status, Data.message);
                } else {
                    setStatus(Data);
                    await NotificationSound('INFO', `Success: ${Data.SuccessCount} Error: ${Data.ErrorCount}`);
                }
            } else {
                await NotificationSound('ERROR', 'Header Format is not valid!');
                BulkClearData(setName);
            }
        } else {
            await NotificationSound('ERROR', 'Please Choose File With Valid Data!');
            BulkClearData(setName);
        }
    };

    const groupDataByProductCode = (sheet1, sheet2, sheet3) => {
        const groupedData = {};

        sheet1.forEach(record => {
            if (!groupedData[record.AwbNo]) {
                groupedData[record.AwbNo] = {
                    ...record,
                    weightDetail: [],
                    descriptionDetails: [],

                };
            }
        });

        sheet2.forEach(detail => {
            if (groupedData[detail.AwbNo]) {
                groupedData[detail.AwbNo].weightDetail.push(detail);
            }
        });

        sheet3.forEach(detail => {
            if (groupedData[detail.AwbNo]) {
                groupedData[detail.AwbNo].descriptionDetails.push(detail);
            }
        });

        return Object.values(groupedData);
    };

    const DownloadFormat = async () => {
        await DownloadFileAtURL('/PacketBooking.xlsx');
    };

    //End Bulk Upload



    useEffect(() => {
        // inputrefs.current['txtCountryCode'].focus();
        document.title = 'Import Packet Booking'
    }, [])

    return (
        <>
            <div className='main-card card border-0'>
                <div className='card-header mb-1'>
                    <h6 className="m-0">{menuText ? menuText : FindTranslatedKey('Import Packet Booking')}</h6>

                </div>
                <div className='card-body row'>

                    <div className='d-flex col-md-6 col-lg-4 h-25'>
                        <ImportButton
                            handleBulk={handleBulk}
                            BulkSubmit={(e) => BulkSubmit(e)}
                            downloadFormat={DownloadFormat}
                            ErrorData={ErrorData}
                            Status={Status}
                            HeaderFormat="PayMode, Active"
                            fileName={Name}
                        >
                        </ImportButton>
                    </div>

                </div>
            </div>


        </>
    )
}

export default ImportPacketBooking;